export const portraitImageData = {
    hero: {
        "images": [
            "hero/portrait/IMG_0420.jpg",
            "hero/portrait/IMG_0929.jpg",
            "hero/portrait/IMG_0955.jpg",
            "hero/portrait/IMG_6987.jpg",
            "hero/portrait/IMG_7950.jpg",
            "hero/portrait/IMG_8711.jpg",
            "hero/portrait/IMG_9147.jpg",
            "hero/portrait/IMG_9689.jpg",
            "hero/portrait/IMG_9713.jpg",
        ],
        light:[
            "light",
            "light",
            "light",
            "light",
            "light",
            "light",
            "light",
            "light",
            "light",

        ]
    }
}

export const landscapeImageData = {
    "hero": { "images":
            [
                "hero/landscape/IMG_0950.jpg",
                "hero/landscape/IMG_1082.jpg",
                "hero/landscape/IMG_8298.jpg",
                "hero/landscape/IMG_8730.jpg",
                "hero/landscape/IMG_8803.jpg",
                "hero/landscape/IMG_9255.jpg",
                "hero/landscape/IMG_9268.jpg",
                "hero/landscape/IMG_9360.jpg",
                "hero/landscape/IMG_0456.jpg",
            ],
        "light":[
            "light",
            "light",
            "light",
            "light",
            "light",
            "light",
            "light",
            "light",
            "light",

        ]
    }
}
